<!-- Documents -->
<eds-header-document-list
  edsSpacing="sm"
  [documents]="documents"
  [viewAllTitle]="'common.view-all' | translate"
  [scrollId]="documentsLink"
  (documentLinkClicked)="documentClicked($event)"
  [theme]="componentTheme"
></eds-header-document-list>
